export default {
  computed: {
    imagePlaceholder() {
      return 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
    },
  },
  methods: {
    formattedSrcset(backendSrcsetStructure) {
      if (backendSrcsetStructure) {
        return Object.keys(backendSrcsetStructure)
          .map((srcsetSize) => {
            return `${backendSrcsetStructure[srcsetSize]} ${srcsetSize}w`
          })
          .join(', ')
      } else return ''
    },
    srcsetStructure(rawSrcset) {
      return {
        srcset: this.formattedSrcset(rawSrcset),
        sizes: this.sizes,
      }
    },
  },
}
